module.exports = __webpack_public_path__ + "img/pk-bg.ddf944fc.png";